// extracted by css-extract-rspack-plugin
export default {"ChatTimeline":"ChatTimeline-NZvndn","chatTimeline":"ChatTimeline-NZvndn"};